type TPSLV2Params = {
    entryPrice: number;
    amount: number;
    leverage: number;
    typeTrade: 'Long' | 'Short';
    decimalsToShow: number;
    tpPercent: number;
    slPercent: number;
};

export const calculateTpSLSubmit = ({
    entryPrice,
    amount,
    leverage,
    tpPercent, // % TP theo amount (vốn bỏ ra)
    slPercent, // % SL theo amount (vốn bỏ ra)
    typeTrade,
    decimalsToShow,
}: TPSLV2Params) => {
    // Giới hạn %

    const tpPercentLimited = tpPercent !== 0 ? Math.max(tpPercent, 900) : 0;
    const slPercentLimited = slPercent !== 0 ? Math.min(Math.abs(slPercent), 90) : 0;
    const positionSize = amount * leverage;
    // Quy đổi % vốn -> PnL tuyệt đối
    const tpPnL = (tpPercentLimited / 100) * amount;
    const slPnL = (slPercentLimited / 100) * amount;

    // Từ PnL -> % thay đổi giá
    const tpRatio = tpPnL / positionSize;
    const slRatio = slPnL / positionSize;
    if (typeTrade === 'Long') {
        const tpPrice = entryPrice * (1 + tpRatio);
        const slPrice = entryPrice * (1 - slRatio);

        return {
            takeProfit:
                tpPercentLimited > 0 ? tpPrice.toFixed(decimalsToShow) : '0',
            stopLoss:
                slPercentLimited > 0 && slPrice > 0
                    ? slPrice.toFixed(decimalsToShow)
                    : '0',
        };
    }

    // Position size

    const tpPrice = entryPrice * (1 - tpRatio);
    const slPrice = entryPrice * (1 + slRatio);

    return {
        takeProfit:
            tpPercentLimited > 0 && tpPrice > 0
                ? tpPrice.toFixed(decimalsToShow)
                : '0',
        stopLoss: slPercentLimited > 0 ? slPrice.toFixed(decimalsToShow) : '0',
    };
};
